<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp;Change Password</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5> Change Password </h5>
                <div class="card">
                  <div class="card-body">
                    <div class="one-line">
                      <label class="ol-label"> Old Password </label>
                      <label class="ol-titik2">:</label>
                      <input type="password" name="oldPassword" v-model="oldPassword" class="form-control form-control-sm">
                    </div>
                    <div class="one-line">
                      <label class="ol-label"> New Password </label>
                      <label class="ol-titik2">:</label>
                      <input type="password" name="newPassword" v-model="newPassword" class="form-control form-control-sm">
                    </div>
                    <div class="one-line">
                      <label class="ol-label"> Confirm New Password </label>
                      <label class="ol-titik2">:</label>
                      <input type="password" name="confirmPassword" v-model="confirmPassword" class="form-control form-control-sm">
                    </div>                      
                    </div>
                    <div id="wrapperr" class="mb-3 mr-4">
                      <div id="c1">
                      </div>
                      <div id="c2">
                        <button class="btn btn-primary btn-sm" @click="cekField"> Update Password </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <!-- /#page-content-wrapper -->
    <!-- Modal Save-->
    <div class="modal fade" id="modalUpdatePassword" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Update Password</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p>Are you sure to update password?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" @click="updatePassword" v-if="loadingButton === false">Update</button>
              <button type="button" class="btn btn-primary" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;"> Update </button>
            </div>
          </div>
        </div>
    </div>
    <!-- endModal -->
  </div>
</template>

<script>
  import SideBar from './SideBar'
  export default {
  name: 'ProductAddPage',
  components:{
    SideBar
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewProduct: false,
      viewPayment: false,
      viewResolution: false,
      viewPartner: false,
      dataOrder: [],
      totalPage:0,
      totalData:0,
      currentPage:1,
      orderId:"",
      companyName:"",
      statusOrder:"",
      oldPassword:"",
      newPassword:"",
      confirmPassword:"",
      loadingButton: false
    }
  },
  methods: {
    openModal(x) {
      $("#modal"+x).modal('show')
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles')
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == 18){
          this.viewDashboard = true
        }else{
          this.viewDashboard = false
        }
        if( this.permission[i] == 18){
          this.viewOrder = true
        }else{
          this.viewOrder = false
        }
        if( this.permission[i] == 18){
          this.viewProduct = true
        }else{
          this.viewProduct = false
        }
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    cekField(){
      if (this.oldPassword.length > 0 && this.newPassword.length > 0 && this.confirmPassword.length > 0) {
              this.openModal('UpdatePassword')
      }else{
        swal("Sorry", "Field must be fill", "error", {
          button: "Ok",
        })
        this.logining = 0;
      }
    },
    updatePassword () {
      this.loadingButton = true
      this.$http.post(process.env.UPDATE_PASSWORD, {
                user_email: localStorage.getItem('user_email'),
                password: this.oldPassword.replace(this.spaceRegex, ' '),
                password_new: this.newPassword.replace(this.spaceRegex, ' '),
                password_confirm: this.confirmPassword.replace(this.spaceRegex, ' ')
              }, {
                headers: { 'Asani-Token': localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status === 200) {
                  $('#modalUpdatePassword').modal('hide');
                  swal("Success", response.data.message, "success", {
                    button: "Ok",
                  })
                  this.handleLogout()  
                } else {
                  $('#modalUpdatePassword').modal('hide');
                  this.loadingButton = false
                  swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
                }
              })
              .catch((error) => {
                swal("Sorry", error.response.data.message, "error", {
                  button: "Ok",
                }).then(v => {
                  if(error.response.data.status == 401) {
                    this.handleLogout()
                  }
                })
              })
    }
  },
  created(){
          this.admin = localStorage.getItem('admin_name')
          this.cekLogin()
          this.cekPermission()
  }
}
    </script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .duration{
    width: 150px;
  }

    #wrapperr{
      overflow:auto;
      margin: 5px 3px;
    }

    #c1{
     float:left;
    }

    #c2{
      float: right;  
    }
    .input-group-addon {
      padding: 7px 12px;
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      color: #555;
      text-align: center;
      background-color: #eee;
      border: 1px solid #ccc;
      border-radius: 4px 0px 0px 4px;
      border-right: none;
      margin: 0px 0px 0px 10px;
      height: fit-content;
    }

    .price{
      max-width: 150px;
    }

    .label-addon-rp{
      margin: 1px 0px;
    }

    .permonth{ 
      margin: 5px 0px 5px 5px;
    }

    .one-file{
      margin: 0px 10px;
    }

    .one-line-file{
      display: grid;
    }

    .img-responsive{
      width: 270px;
      height: auto;
    }

    .storage-type{
      max-width: 100px;
    }

    .one-line{
      display: flex;
      margin: 5px 0px;
    }

    .one-line .ol-label{
      width: 208px;
      margin: 2px 0px;
    }

    .one-line .ol-label.storage{
      width: 215px;
      margin: 2px 0px;
    }

    .one-line .ol-label-photo{
      width: 155px;
      margin: 2px 0px;
    }

    .one-line .ol-label-dur{
      width: 218px;
      margin: 2px 0px;
    }

    .one-line .ol-label-reason{
      width: 88px;
      margin: 2px 0px;
    }

    .one-line .ol-titik2{
      width: 15px;
      margin: 2px 0px;
    }

    .one-line .ol-value{
      width: 100%;
      margin: 2px 0px;
    }

    .pagination{
      padding: 0px 0;
    }

    .pagination ul{
      margin: 0;
      padding: 0;
      list-style-type: none;
    }

    .pagination a{
      display: inline-block;
      padding: 1px 6px;
      color: #222;
    }

    .p8 a{
      background-color: #2797FB;
      /*margin: auto 5px;*/
      color: #fff;
      /*font-weight: bold;*/
      border: 1px solid #2797FB;
    }

    .p8 a:hover{
      text-decoration: none;
    }
    .p8 a.page:hover{
      text-decoration: none;
      color: #fff;
    }

    .p8 .is-active{
      background-color: #fff;
      color: #2797FB;
    }

    .alignleft {
      float: left;
    }
    .alignright {
      float: right;
    }

    .pagg{
      display: inline-flex;
      overflow:auto;
    }

    .total-data{
      padding: 11px 0px;
      font-size: 14px;
      color: #343A40;
    }
    #wrapperr{
      overflow:auto;
      margin: 5px 3px;
    }

    #c1{
     float:left;
   }

   #c2{
    float: right;  
  }

  .search-table{
    padding-bottom: 7px;
    margin-top: -5px;
    margin-left: -15px;
  }
  .active{
    color: #2797FB;
  }
  .right-dropdown{
    margin-left: 7px;
  }
  .account-div{
    margin: 2px 2px;
  }
  .right-arrow{
    margin-left: auto;
  }
  .brand-logo{
    width: 120px;
  }
  .menu-title{
    margin-left: 1.125rem;
  }
  .menu-title-order{
    margin-left: 1.95rem;
  }
  .menu-title-payment{
    margin-left: 1.525rem;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    /*width: 200px;*/
    /*background-color: #f1f1f1;*/
  }

  li.sidebar a {
    display: block;
    color: #000;
    padding: 8px 63px;
    text-decoration: none;
  }

  li a.active {
    background-color: #4CAF50;
    color: white;
  }

  li a:hover:not(.active) {
    background-color: #2797FB;
    color: white;
  }
  .nav-side-menu {
    overflow: auto;
    font-family: verdana;
    font-size: 12px;
    font-weight: 200;
    background-color: #2e353d;
    position: fixed;
    top: 0px;
    width: 300px;
    height: 100%;
    color: #e1ffff;
  }
  .nav-side-menu .brand {
    background-color: #23282e;
    line-height: 50px;
    display: block;
    text-align: center;
    font-size: 14px;
  }
  .nav-side-menu .toggle-btn {
    display: none;
  }
  .nav-side-menu ul,
  .nav-side-menu li {
    list-style: none;
    padding: 0px;
    margin: 0px;
    line-height: 35px;
    cursor: pointer;
  }
  .nav-side-menu ul :not(collapsed) .arrow:before,
  .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px){
    .mobile-div{
      padding: 2px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ChangePasswordPage.vue